import { ICatalogSnapshotToShop, IPaginatedData, QueryManyBuilder } from '@app/common';
import { providesList, rootApi } from '../api';

export const catalogSnapshotToShopApi = rootApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    readManyCatalogSnapshotToShops: builder.query<IPaginatedData<ICatalogSnapshotToShop>, QueryManyBuilder<ICatalogSnapshotToShop>>({
      providesTags: (result) => providesList(result?.data, 'CatalogSnapshotToShops'),
      query: (params) => ({
        url: 'catalog-snapshot-to-shops',
        params,
        method: 'GET',
      }),
    }),
    updateCatalogSnapshotToShop: builder.mutation<ICatalogSnapshotToShop, Partial<ICatalogSnapshotToShop>>({
      invalidatesTags: (_, __, arg) => [
        { type: 'CatalogSnapshotToShops', id: arg._id },
        { type: 'CatalogSnapshotToShops', id: 'LIST' },
      ],
      query: ({ _id, ...body }) => ({
        url: `catalog-snapshot-to-shops/${_id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});
